import { ReactComponent as Slide1 } from 'assets/images/home-slide-1.svg';
import { ReactComponent as Slide2 } from 'assets/images/home-slide-2.svg';
import { ReactComponent as Slide3 } from 'assets/images/home-slide-3.svg';
import { ReactComponent as Slide4 } from 'assets/images/home-slide-4.svg';
import { ReactComponent as Slide5 } from 'assets/images/home-slide-5.svg';
import { ReactComponent as Slide6 } from 'assets/images/home-slide-6.svg';
import Text from 'styles/typography';
import { StepProps } from './Step';
import { Slide2Ul } from './styles';

const data: StepProps[] = [
  {
    img: Slide1,
    imgAlt: 'slide-1',
    content: (
      <Text>
        Antes de avisar um sinistro, veja aqui algumas{' '}
        <span className="tips"> dicas importantes</span>
      </Text>
    ),
    contentSize: 'large',
  },
  {
    img: Slide2,
    imgAlt: 'slide-2',
    title: (
      <Text>
        Fique atento aos documentos obrigatórios:{' '}
        <span className="upper tipsBlock">
          Sem eles não será possível realizar o aviso de sinistro!
        </span>
      </Text>
    ),
    content: (
      <Slide2Ul>
        <li>Declaração de inexistência de outros seguros</li>
        <li>Cartão CNPJ</li>
        <li>Comprovante de endereço do local da ocorrência</li>
        <li>Comprovante de dados bancários</li>
      </Slide2Ul>
    ),
  },
  {
    img: Slide3,
    imgAlt: 'slide-3',
    title: (
      <Text>
        Informe corretamente:{' '}
        <span className="tipsBlock">
          Local da Ocorrência e o Tipo do Sinistro
        </span>
      </Text>
    ),
    content: (
      <Text>
        É muito importante que estas informações estejam{' '}
        <span className="upper tips"> Atualizadas </span> para um bom andamento
        e agilidade do processo além de evitar problemas futuros.
      </Text>
    ),
  },
  {
    img: Slide4,
    imgAlt: 'slide-4',
    title: (
      <Text>
        Descrição da Ocorrência:{' '}
        <span className="tipsBlock">Descreva detalhadamente o ocorrido.</span>
      </Text>
    ),
    content: (
      <Text>
        A descrição da ocorrência com detalhamento pode conter informações
        importantes para{' '}
        <span className="tips">
          &nbsp;melhor acionar as coberturas necessárias&nbsp;
        </span>{' '}
        para um bom andamento do processo.
      </Text>
    ),
  },
  {
    img: Slide5,
    imgAlt: 'slide-5',
    title: (
      <Text>
        <span className="tips">Importantes etapas </span> durante o processo:
      </Text>
    ),
    content: (
      <Text>
        Você também poderá acompanhar todas as etapas do processo, desde:{' '}
        <span className="tips">
          &nbsp;Envio de documentos, análise seguradora, aceites dos valores
          apurados e pagamento da indenização.
        </span>
      </Text>
    ),
  },
  {
    img: Slide6,
    imgAlt: 'slide-6',
    title: (
      <Text className="centerTips">
        Após o aviso de sinistro{' '}
        <span className="tips">
          &nbsp;acompanhe o status do processo diariamente.
        </span>
      </Text>
    ),
  },
];

export default data;
